import React from 'react'
import { RichText } from '../../helpers/react'
import { Badge, Card, Icon } from '../../../atoms'
import Button from '../../../atoms/button'
import classNames from 'classnames'
import ImgixImage from '../../helpers/imgix-image'
import Form from '../../form'
import { useEntity } from '../../helpers/selectors'

const CallOutCard = (props) => {
  const { content, jsonBody, brand, sys, rawName, variant, form, image } = props
  const formData = useEntity(form)
  const imageData = useEntity(image)
  const isCallOutCardWithHighlight = Boolean(jsonBody.highlightText)

  return (
    <Card
      className={classNames('CallOutCard', {
        HasHighlight: isCallOutCardWithHighlight,
        HasBadge: jsonBody.badge?.isCrown,
      })}
      style={{
        background: jsonBody.background,
        backgroundColor: jsonBody.backgroundColor,
        border: jsonBody.border,
        color: jsonBody.textColor,
      }}
    >
      {jsonBody.badge && (
        <Badge
          icon={jsonBody.badge.icon}
          text={jsonBody.badge.text}
          variant={jsonBody.badge.variant}
          brand={brand}
          isCrown={jsonBody.badge.isCrown}
          size={jsonBody.badge.size}
        />
      )}

      {jsonBody.image && jsonBody.image.inHeader && (
        <div className='CallOutCard-header-logo-wrapper'>
          <ImgixImage src={jsonBody.image.src} alt={jsonBody.image.alt} width={260} />
        </div>
      )}

      {jsonBody.heading && (
        <h3
          className='CallOutCard-heading'
          style={{
            color: `${jsonBody.textColor} !important`,
          }}
        >
          {jsonBody.heading}
        </h3>
      )}
      {jsonBody.subHeading && <p className='CallOutCard-subHeading'>{jsonBody.subHeading}</p>}

      {isCallOutCardWithHighlight && (
        <div className='HasHighlight-highlight'>
          {jsonBody.highlightIcon && (
            <div className='HasHighlight-highlight-icon-wrapper'>
              <Icon
                glyph={jsonBody.highlightIcon}
                brand={brand}
                ariaLabel={jsonBody.highlightIcon}
                size={24}
              />
            </div>
          )}
          <p className='HasHighlight-highlight-text'>{jsonBody.highlightText}</p>
        </div>
      )}

      {content?.content && (
        <div className={`CallOutCard-content${!jsonBody.subHeading ? '--nosubHeading' : ''}`}>
          <RichText content={content.content} />
        </div>
      )}

      <div className='CallOutCard-footer'>
        <div className='CallOutCard-footer-cta-wrapper'>
          {jsonBody.button && (
            <Button
              variant={jsonBody.button.variant}
              size='md'
              href={jsonBody.button.href}
              dataClickTracking={{
                component_category: 'platinum-component',
                component_id: sys?.id,
                component_name: 'product-call-out',
                contentful_name: rawName,
                contentful_variant: variant,
                link_path: jsonBody.button.href,
              }}
              openInNewTab
              withIcon={true}
            >
              {jsonBody.button.text}
            </Button>
          )}
          {form && <Form {...formData} />}
          {jsonBody.link && (
            <div className='CallOutCard-footer-link'>
              <a
                href={jsonBody.link.href}
                style={{
                  color: jsonBody.textColor,
                }}
              >
                {jsonBody.link.text}
              </a>
            </div>
          )}
        </div>
        {image && (
          <div className='CallOutCard-footer-logo-wrapper'>
            <ImgixImage
              src={imageData.file.url}
              alt={imageData.description ?? imageData.title}
              width={260}
            />
          </div>
        )}
        {jsonBody.image && !jsonBody.image.inHeader && (
          <div className='CallOutCard-footer-logo-wrapper'>
            <ImgixImage src={jsonBody.image.src} alt={jsonBody.image.alt} width={260} />
          </div>
        )}
      </div>
    </Card>
  )
}

export default CallOutCard
